import { http } from '@/http'

/**
 * Recorrido de un turno (DEF-ADM-013). Solo lectura.
 */
export default {
  // Recorrido completo del turno: info + GPS points + eventos + resumen.
  getShiftRoute(shiftId) {
    return http.get(`/api/v1/shifts/${shiftId}/route`)
  }
}
